import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import styles from "css/mobile/mypage.module.css";
import { Avatar, Checkbox, Drawer, Tabs } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Input from "antd/es/input/Input";
import { useTranslation } from "react-i18next";
import { Button } from "antd/es/radio";
import DeptTree from "components/common/tree/deptTree";

export default function ResParticipantSideBox({
  isOpenParticpantSideBox,
  closeParticipantSideBox,
  participantChange,
  treeMemberList,
  searchMemberList,
  recentMemberList,
  setTreeMemberList,
  setSearchMemberList,
  setRecentMemberList,
  schedule,
}) {
  const { t, i18n } = useTranslation();
  const [searchMemberValue, setSearchMemberValue] = useState("");

  //________________________________________________
  // tab1 (tree Member) ____________________________

  // tab2 (search Member) __________________________
  const handleSearchMember = (value) => {
    setSearchMemberValue(value);
    if (value) {
      searchMembers(value);
    } else {
      setSearchMemberList([]);
    }
  };
  // searched MemberList
  const searchMembers = (value) => {
    const params = { KEY_WORD: value };
    axios
      .post("/user/searchList", params)
      .then((res) => {
        if (res.status === 200) {
          let updatedMembers = [];

          res.data.map((member) => {
            const updatedMember = schedule.PARTICIPANT_LIST.find(
              (participant) => member.MEMBER_ID === participant.MEMBER_ID
            );
            if (updatedMember) {
              return updatedMembers.push({
                ...member,
                isChecked: !member.isChecked,
              });
            } else {
              return updatedMembers.push(member);
            }
          });
          setSearchMemberList(updatedMembers);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // checkbox status update
  const handleSearchMemberCheck = (member) => {
    setSearchMemberList(
      searchMemberList.map((m) =>
        m.MEMBER_ID === member.MEMBER_ID ? { ...m, isChecked: !m.isChecked } : m
      )
    );
    member.isChecked = !member.isChecked;

    participantChange(member);
  };

  // tab3 (recent Member) __________________________
  const recentMembers = () => {
    axios
      .get("/schedule/myParticipantList")
      .then((res) => {
        if (res.status === 200) {
          setRecentMemberList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // checkbox status update
  const handleRecentMemberCheck = (member) => {
    setRecentMemberList(
      recentMemberList.map((m) =>
        m.MEMBER_ID === member.MEMBER_ID ? { ...m, isChecked: !m.isChecked } : m
      )
    );
    member.isChecked = !member.isChecked;

    participantChange(member);
  };

  const closed = () => {
    setRecentMemberList(
      recentMemberList.map((m) => (true ? { ...m, isChecked: false } : m))
    );
    setSearchMemberList(
      searchMemberList.map((m) => (true ? { ...m, isChecked: false } : m))
    );
  };
  //________________________________________________
  useEffect(() => {
    if (!isOpenParticpantSideBox) {
      closed();
    }
    setReset(!reset);
    handleSearchMember("");
  }, [isOpenParticpantSideBox]);

  const [groupList, setGroupList] = useState("");
  const organization = useCallback(() => {
    axios.get("/address/treeList").then((res) => {
      if (res.status === 200) {
        setGroupList(res.data);
      }
    });
  }, []);
  useEffect(() => {
    organization();
  }, [organization, isOpenParticpantSideBox]);
  const [reset, setReset] = useState(false);
  const [checkboxTrigger, setCheckboxTrigger] = useState(false);
  useEffect(() => {
    setCheckboxTrigger(!checkboxTrigger);
  }, [schedule.PARTICIPANT_LIST]);
  //-----------------------------

  const tabItems = [
    {
      key: "2",
      label: t("LABEL.CONTACT"),
      children: (
        <div className={styles.tabsItemArea}>
          <Input
            className={styles.searchBox}
            value={searchMemberValue}
            onChange={(e) => handleSearchMember(e.target.value)}
            placeholder={t("PLACEHOLDER.INPUT.PTCP_EMAIL")}
          />
          <div className={styles.tabsItemHeader} style={{ display: "none" }}>
            <ul className={styles.tabsItemControls}>
              <li>
                <Checkbox />
              </li>
              <span>t("LABEL.ALL") {searchMemberList.length}</span>
              <Button>정렬</Button>
            </ul>
          </div>
          <div className={styles.tabsItemContent}>
            {searchMemberList.map((member) => (
              <ul className={styles.tabsItem_members} key={member.MEMBER_ID}>
                <li className={styles.tabsItem_memberChkbox}>
                  <Checkbox
                    className={styles.boxDetail}
                    checked={member.isChecked}
                    onChange={() => handleSearchMemberCheck(member)}
                  />
                </li>
                <li className={styles.tabsItem_memberIcon}>
                  <img
                    src={
                      process.env.REACT_APP_CLIENT_URL + "img/menu/avatar.png"
                    }
                    alt="avatar"
                  />
                </li>
                <li className={styles.tabsItem_memberNm}>
                  {member.DISPLAY_NM}
                </li>
                <li className={styles.tabsItem_memberEmail}>{member.EMAIL}</li>
              </ul>
            ))}
          </div>
        </div>
      ),
    },
    {
      key: "1",
      label: t("LABEL.CHART"),
      children: (
        <DeptTree
          treeData={groupList}
          onUserSelect={(members) => {
            members.forEach((member) => handleSearchMemberCheck(member));
          }}
          resetTrigger={reset}
          defaultCheckedUsers={schedule.PARTICIPANT_LIST}
          checkBoxTrigger={checkboxTrigger}
        />
      ),
    },
    {
      key: "3",
      label: t("LABEL.RECENT"),
      children: (
        <div className={styles.tabsItemContent}>
          {recentMemberList.map((member) => (
            <ul className={styles.tabsItem_members} key={member.MEMBER_ID}>
              <li className={styles.tabsItem_memberChkbox}>
                <Checkbox
                  className={styles.boxDetail}
                  checked={member.isChecked}
                  onChange={() => handleRecentMemberCheck(member)}
                />
              </li>
              <li className={styles.tabsItem_memberImage}>
                <Avatar size="small" icon={<UserOutlined />} />
              </li>
              <li className={styles.tabsItem_memberEmail}>{member.EMAIL}</li>
              <li className={styles.tabsItem_memberNm}>{member.DISPLAY_NM}</li>
            </ul>
          ))}
        </div>
      ),
    },
  ];

  const tabsChange = (num) => {
    if (num === "1") {
    } else if (num === "2") {
    } else {
      recentMembers();
    }
  };

  return (
    <>
      <Drawer
        className={styles.sidebox_drawer}
        open={isOpenParticpantSideBox}
        onClose={closeParticipantSideBox}
        placement="right"
        maskClosable={true}
        height="auto"
        title={null}
        styles={{ header: { display: "none" } }}
      >
        <div className={styles.sideBoxContainer}>
          <div className={styles.sideboxHeader}>
            <img
              src={
                process.env.REACT_APP_CLIENT_URL +
                "img/mobile/mypage/close_left.png"
              }
              alt="close"
              onClick={closeParticipantSideBox}
            />
            <span className={styles.sideboxTitle}>
              {t("LABEL.TITLE.CONTACT_INFO")}
            </span>
            <span
              className={styles.sideboxConfirmBtn}
              onClick={closeParticipantSideBox}
            >
              {t("BTN.COMPLETE")}
            </span>
          </div>
          <div className={styles.tabsArea}>
            <Tabs
              defaultActiveKey="2"
              items={tabItems}
              tabBarGutter={i18n.language === "en-US" ? 23 : 42}
              onChange={tabsChange}
            />
          </div>
        </div>
      </Drawer>
    </>
  );
}
